import { Command } from 'commander';
import { createProjectInspectCommand } from './inspect.js';

export function createProjectCommand(): Command {
    const command = new Command('project').description('Phân tích và quản lý trạng thái dự án Jai1');
    command.addCommand(createProjectInspectCommand());
    return command;
}
